/** Next best action for Study hub — what / when hint for the user. */
export function getStudyDoNow({ due, reviewedToday, dailyGoal, savedCount }) {
  const goal = dailyGoal > 0 ? dailyGoal : 10;
  const left = Math.max(0, goal - reviewedToday);

  if (due > 0) {
    return {
      urgent: true,
      eyebrow: 'Do this now',
      title: 'Clear your review queue',
      detail: `${due} due · same-day reviews stick best (~5–20 min).`,
      to: '/review',
      cta: 'Start review',
    };
  }

  if (left > 0) {
    return {
      urgent: false,
      eyebrow: 'Do this now',
      title: 'Work toward today\'s review goal',
      detail: `${left} left toward ${goal}/day · read in Library, save for Review.`,
      to: '/library',
      cta: 'Open library',
    };
  }

  if (savedCount > 0) {
    return {
      urgent: false,
      eyebrow: 'Do this now',
      title: 'Practice your saved deck',
      detail: 'Goal met · reinforce saves with flashcards (~10 min).',
      to: '/practice',
      cta: 'Start practice',
    };
  }

  return {
    urgent: false,
    eyebrow: 'Do this now',
    title: 'Pick something to learn',
    detail: 'Library or Learn → save what you want to remember.',
    to: '/library',
    cta: 'Browse library',
  };
}

/** Instant fallback for “What should I learn now?” while /api/v1/learning/next is slow. */
export function studyDoNowToNextAction(doNow) {
  if (!doNow) return null;
  let type = 'LEARN';
  if (doNow.to === '/review') type = 'REVIEW';
  else if (doNow.to === '/practice') type = 'PRACTICE';
  return {
    type,
    reason: doNow.detail,
    linkPath: doNow.to,
    estimatedMinutes: null,
    questionCount: null,
    topic: null,
    localFallback: true,
  };
}
